// extracted by css-extract-rspack-plugin
export default {"root":"root-pENOaB","title":"title-6andnE"};